import { State } from "@hookstate/core";
import Cross from "../../assets/icons/Cross";
import Plus from "../../assets/icons/Plus";
import UploadDoc from "../../assets/icons/UploadDoc";
import DefaultButton from "../default-button/DefaultButton";
import InputField from "../input-field/InputField";
import { useUniversalFindAll } from "../../hooks/universal";
import { ClubState } from "../../types";
import { accessGlobalMiscState } from "../../stores/misc";
import { HasRole } from "../HasRole";

type ClubControlsPropsType = {
  handleOpenAddClub: (value: boolean) => void;
  localState: State<ClubState>;
  onExport?: () => void;
};

const ClubControls = (props: ClubControlsPropsType) => {
  const allClubCategories: any[] = useUniversalFindAll("ClubCategory");
  const localState = props.localState;
  const state = localState.get();
  const { selectedCategoryId, search, clubType, clubTypeMeta } = state;

  const clubCategories = allClubCategories.filter(
    (c) => !clubType || clubType?.id === c.club_type_id
  );

  const onCreateClubClick = () => {
    accessGlobalMiscState().set("clubFormMode", "create");
    props.handleOpenAddClub(true);
  };

  const onInputChangeNative =
    (key: string) =>
      (
        e:
          | React.ChangeEvent<HTMLInputElement>
          | React.ChangeEvent<HTMLSelectElement>
      ) => {
        localState.merge({
          [key]: e.target.value,
        });
      };

  return (
    <div className="flex flex-row gap-4 items-center mb-4">
      <div className="flex flex-row items-center flex-[39]">
        <InputField
          wrapperClassName="flex-1"
          handleChange={onInputChangeNative("search")}
          value={search}
          type="text"
          placeholder={clubTypeMeta?.searchText}
          additionalClassName="px-4 py-3 !bg-[#F0F3FA] rounded-lg !placeholder-[#AFB7CA] mt-0 border-none"
        />
      </div>
      <div className="flex flex-row flex-[28] items-center gap-2">
        <label htmlFor="category" className="text-sm text-gray-700">
          Направление
        </label>
        <select
          id="category"
          className="border border-gray-200 rounded-md px-4 py-3 w-full focus:outline-none bg-blue-100 opacity-40 text-black"
          value={selectedCategoryId}
          onChange={onInputChangeNative("selectedCategoryId")}
        >
          <option value="" selected>
            Все
          </option>
          {clubCategories.map((c: Record<string, any>) => (
            <option value={c.id}>{c.name}</option>
          ))}
        </select>
        <DefaultButton
          additionalStyle="text-red-500 bg-red-100 border-red-500 px-2 opacity-[0.2] hover:bg-red-100"
          Icon={Cross}
          buttonText=""
        />
      </div>
      <div className="flex flex-row flex-[28] gap-4 justify-end ">
        <HasRole roles={["create_clubs"]}>
          <DefaultButton
            additionalStyle="text-green-500 border-green-500 px-3 hover:bg-green-100 text-nowrap"
            Icon={Plus}
            buttonText="Создать клуб"
            onClick={onCreateClubClick}
          />
        </HasRole>
        <DefaultButton
          additionalStyle="border-gray-500 text-gray-500 px-3 hover:bg-gray-100"
          Icon={UploadDoc}
          buttonText="Выгрузить"
          onClick={props.onExport}
        />
      </div>
    </div>
  );
};

export default ClubControls;
